module.exports = __webpack_public_path__ + "img/Icon__Discrimination.3db21f49.svg";